import React from 'react'
import { LRX_41202_UC_IN_MARK_ALL_ITEM_FULFILLMENT } from '../../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../../util/feature-cache'
import { Step2Add } from './Step2Add'
import type { Step2AddProps } from './Step2Add'
import { Step2AddLegacy } from './Step2AddLegacy'

export const Step2AddWrapper: React.FC<Step2AddProps> = props => {
  const isUnifiedMarkAllItemFulfillmentEnabled = getFeatureFromCache(
    LRX_41202_UC_IN_MARK_ALL_ITEM_FULFILLMENT
  )

  return isUnifiedMarkAllItemFulfillmentEnabled ? (
    <Step2Add {...props} />
  ) : (
    <Step2AddLegacy {...props} />
  )
}

export { Step2AddWrapper as Step2Add }
export type { Step2AddProps }
